import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { path: '/', label: 'ホーム' },
    { path: '/today-flower', label: '今日の誕生花' },
    { path: '/plants', label: '植物図鑑' },
    { path: '/flower-language', label: '花言葉' },
    { path: '/prefecture-flowers', label: '県の花' },
    { path: '/celebration-flowers', label: 'お祝い花' },
    { path: '/flower-shop', label: '花の購入' },
    { path: '/omikuji', label: '花のおみくじ' },
    { path: '/knowledge', label: '花の特徴' },
    { path: '/essay', label: 'エッセイ' },
    { path: '/events', label: 'イベント' },
    { path: '/garden', label: '家庭菜園' },
    { path: '/contact', label: 'お問い合わせ' },
  ];

  return (
    <header className="bg-white shadow-sm border-b border-green-100">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center space-x-3">
            <div className="relative">
              <div className="w-10 h-10 bg-gradient-to-br from-emerald-400 via-green-400 to-teal-400 rounded-full flex items-center justify-center shadow-lg">
                <i className="ri-leaf-line text-white text-lg"></i>
              </div>
              <div className="absolute -top-1 -right-1 w-4 h-4 bg-gradient-to-br from-pink-400 to-rose-400 rounded-full flex items-center justify-center">
                <i className="ri-heart-fill text-white text-xs"></i>
              </div>
            </div>
            <div className="flex flex-col">
              <span className="text-lg font-bold text-green-800 leading-tight" style={{ fontFamily: '"Pacifico", serif' }}>
                みんなの植物
              </span>
              <span className="text-xs text-green-600 leading-tight">
                ～モモちゃん畑～
              </span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <Link to="/" className="text-gray-700 hover:text-green-600 transition-colors whitespace-nowrap">ホーム</Link>
            <Link to="/today-flower" className="text-gray-700 hover:text-green-600 transition-colors whitespace-nowrap">今日の誕生花</Link>
            <Link to="/flower-language" className="text-gray-700 hover:text-green-600 transition-colors whitespace-nowrap">花言葉</Link>
            <Link to="/plants" className="text-gray-700 hover:text-green-600 transition-colors whitespace-nowrap">植物図鑑</Link>
            <Link to="/prefecture-flowers" className="text-gray-700 hover:text-green-600 transition-colors whitespace-nowrap">都道府県の花</Link>
            <Link to="/celebration-flowers" className="text-gray-700 hover:text-green-600 transition-colors whitespace-nowrap">お祝い花</Link>
            <Link to="/flower-shop" className="text-gray-700 hover:text-green-600 transition-colors whitespace-nowrap">花の購入</Link>
            <Link to="/knowledge" className="text-gray-700 hover:text-green-600 transition-colors whitespace-nowrap">花の特徴</Link>
            <Link to="/essay" className="text-gray-700 hover:text-green-600 transition-colors whitespace-nowrap">エッセイ</Link>
            <Link to="/omikuji" className="text-gray-700 hover:text-green-600 transition-colors whitespace-nowrap">花おみくじ</Link>
            <Link to="/contact" className="text-gray-700 hover:text-green-600 transition-colors whitespace-nowrap">お問い合わせ</Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md-hidden p-2 rounded-md hover:bg-gray-100 cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-100">
            <nav className="flex flex-col space-y-4">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`text-sm font-medium transition-colors hover:text-green-600 ${
                    location.pathname === item.path ? 'text-green-600' : 'text-gray-700'
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.label}
                </Link>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
